import { t } from '../i18n/strings'
import { navigate } from '../state'
import { el } from './dom'

export function renderPrivacy(): HTMLElement {
  const ui = t()
  return el('section', { className: 'panel' }, [
    el('h2', { className: 'panelTitle', text: ui.privacyTitle }),
    el('p', {
      className: 'panelHint',
      text: ui.privacyHint,
    }),
    el('div', { className: 'policyBody' }, [
      el('h3', { text: ui.privacyCollectTitle }),
      el('p', { text: ui.privacyCollectBody }),
      el('h3', { text: ui.privacyAdsTitle }),
      el('p', { text: ui.privacyAdsBody }),
      el('h3', { text: ui.privacyContactTitle }),
      el('p', { text: ui.privacyContactBody }),
    ]),
    el('button', {
      className: 'btn btnPrimary',
      attrs: { type: 'button' },
      text: ui.privacyBack,
      on: { click: () => navigate('app') },
    }),
  ])
}
